import { AlertTriangle } from 'lucide-react';
import { RecallAlert } from './RecallAlert';

export function AlertBanner({ alerts, onDismiss, dm }) {
  if (!alerts.length) return null;
  return (
    <div style={{ padding: '0 22px', marginTop: 8 }}>
      {alerts.map(a => a.type === 'recall' ? <RecallAlert key={a.id} alert={a} onAck={onDismiss} dm={dm} /> : (
        <div key={a.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', padding: '10px 14px', background: a.type === 'supply_low' ? 'rgba(232,112,48,0.12)' : 'rgba(232,80,80,0.12)', border: `1px solid ${a.type === 'supply_low' ? 'rgba(232,112,48,0.5)' : 'rgba(232,80,80,0.5)'}`, borderRadius: 12, marginBottom: 8 }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
            <AlertTriangle size={13} style={{ color: a.type === 'supply_low' ? '#e87030' : '#e84040', marginTop: 1, flexShrink: 0 }} />
            <div>
              <div style={{ fontSize: 10, fontFamily: 'monospace', color: a.type === 'supply_low' ? '#e87030' : '#e84040', letterSpacing: '0.08em', marginBottom: 2, fontWeight: '600' }}>{a.type === 'supply_low' ? 'REORDER SOON' : 'BUD WARNING'}</div>
              <div style={{ fontSize: 12, color: dm ? '#c8d8e4' : '#1a3a50' }}>{a.message}</div>
            </div>
          </div>
          <button onClick={() => onDismiss(a)} style={{ background: 'none', border: 'none', color: dm ? '#3a5060' : '#7799aa', cursor: 'pointer', fontSize: 18, lineHeight: 1, padding: '0 0 0 10px', flexShrink: 0 }}>×</button>
        </div>
      ))}
    </div>
  );
}
